import { IssueNotificationEvent } from '@cims-online/shared'
import CIMSNotifications from 'components/CIMSNotifications'
import { useEdit } from './hooks/useEdit'
import RecipientsSelectProvider from 'components/CIMSSelect/common/RecipientsSelect/RecipientsSelectContext'
import IssueNotificationsProvider, {
  useIssueNotificationsContext,
} from './IssueNotificationsContext'
import ViewIssueNotifications from './components/ViewIssueNotifications'

const Notifications: React.VFC = () => {
  const { loading, refetch } = useIssueNotificationsContext()
  return (
    <CIMSNotifications
      events={IssueNotificationEvent.values}
      edit={useEdit()}
      onReload={refetch}
      view={<ViewIssueNotifications />}
      loading={loading}
    />
  )
}

const IssueNotifications: React.VFC = () => {
  return (
    <RecipientsSelectProvider>
      <IssueNotificationsProvider>
        <Notifications />
      </IssueNotificationsProvider>
    </RecipientsSelectProvider>
  )
}

export default IssueNotifications
